import { ref } from 'vue';

export function useAddPartener() {
    const isSubmitting = ref(false);
    const idempotencyKey = ref(crypto.randomUUID());

    function resetIdempotencyKey() {
        idempotencyKey.value = crypto.randomUUID();
    }

    return { isSubmitting, idempotencyKey, resetIdempotencyKey };
}
